import userService from "../../service/user.service";

export const updateUserOnLogout = async (checkTime, currentUser) => {
  await userService.updateUser("logout", {}, currentUser.id);
};
